var indentStyle = {"indentZero":"xcP3i","indentOne":"tSc3G","indentTwo":"Vtb4I","indentThree":"GRg5H","indentFour":"iXV4Z","indentFive":"_6cLco","indentSix":"_0C5Mi"};

export { indentStyle as i };
//# sourceMappingURL=indentation-a9a30e05.js.map
